var languagesCodesListFull = ['en', 'zh', 'zh_HANT', 'fr', 'de', 'hi', 'id', 'it', 'ja', 'ko', 'pl', 'pt', 'ru', 'es', 'th', 'tr', 'vi'];
var TaskItemStatus;
(function (TaskItemStatus) {
  TaskItemStatus["DONE"] = "DONE";
  TaskItemStatus["FAILED"] = "FAILED";
  TaskItemStatus["PENDING"] = "PENDING";
  TaskItemStatus["FAILED_SERVER"] = "FAILED_SERVER";
  TaskItemStatus["FAILED_NSFW"] = "FAILED_NSFW";
  TaskItemStatus["ACCEPTED"] = "ACCEPTED";
  TaskItemStatus["COMPLETED"] = "COMPLETED";
})(TaskItemStatus || (TaskItemStatus = {}));
var BroadcastChannelName;
(function (BroadcastChannelName) {
  BroadcastChannelName["NotificationSync"] = "notification-sync";
})(BroadcastChannelName || (BroadcastChannelName = {}));
var NotificationBroadcastMessages;
(function (NotificationBroadcastMessages) {
  NotificationBroadcastMessages["CLOSE_NOTIFICATION"] = "CLOSE_NOTIFICATION";
})(NotificationBroadcastMessages || (NotificationBroadcastMessages = {}));

export { BroadcastChannelName as B, NotificationBroadcastMessages as N, languagesCodesListFull as l };
//# sourceMappingURL=types-299e9037.js.map
